export default __webpack_public_path__ + "static/shadows-follow-1d3c0a3598a703b2054316cd4fcff42e.png";